import { inject, provide, type InjectionKey } from "vue"

export function provideOnce<T>(key: InjectionKey<T> | string, createValue: () => T): T {
    const injected = inject<T>(key, null as any)

    if (injected !== null) {
        return injected
    }

    const value = createValue()
    provide(key, value)
    return value
}
